import React, { useState, useEffect } from 'react'
import ImageWithBasePath from '../../core/img/imagewithbasebath'
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { ChevronUp, PlusCircle, RotateCcw } from 'feather-icons-react/build/IconComponents';
import { useDispatch, useSelector } from 'react-redux';
import { setToogleHeader } from '../../core/redux/action';
// import Select from 'react-select';
import AddSubcategory from '../../core/modals/inventory/addsubcategory';
import EditSubcategories from './editsubcategories';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import Table from '../../core/pagination/datatable';
import Axios from 'axios';
import { setsubcategotylist_data } from '../../core/redux/action';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { API_BASE_URL, DEL_SUB_CATEGORY, GET_SUB_CATEGORIES } from '../../Config';
import { getUserPermissions } from "../../UserPermissions";
import SpinLoader from '../loader/SpinLoader';


const SubCategories = () => {

    const [userDataSession, setUserDataSession] = useState([]);
    const navigate = useNavigate();


    useEffect(() => {
        const userDataString = sessionStorage.getItem("userData");
        if (userDataString) {
            const userData = JSON.parse(userDataString);
            setUserDataSession(userData);
        } else {
            navigate('/');
            console.log("User data not found in sessionStorage");
        }
    }, []);

    const [permissions, setPermissions] = useState({
        isRead: 'd-none',
        isWrite: 'd-none',
        isDelete: 'd-none',
        isExport: 'd-none'
      });
    
      useEffect(() => {
        const perms = getUserPermissions("Sub Categories");
        setPermissions(perms);
      }, []);

    const dispatch = useDispatch();
    const data = useSelector((state) => state.toggle_header);
    const dataSource = useSelector((state) => state.subcategotylist_data) || [];
    const [searchQuery, setSearchQuery] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (userDataSession && userDataSession.OrgId) {
            setLoading(true);

            Axios.get(`${API_BASE_URL}${GET_SUB_CATEGORIES}?OrgId=${userDataSession.OrgId}`)
                .then(response => {
                    if (response.data.Status) {
                        dispatch(setsubcategotylist_data(response.data.ResultData));
                        setLoading(false);
                    } else {
                        console.error('Error fetching data:', response.data.Message);
                        setLoading(false);
                    }
                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                    setLoading(false);
                });
        }
    }, [dispatch, userDataSession]);

    const renderTooltip = (props) => (
        <Tooltip id="pdf-tooltip" {...props}>
            Pdf
        </Tooltip>
    );
    const renderExcelTooltip = (props) => (
        <Tooltip id="excel-tooltip" {...props}>
            Excel
        </Tooltip>
    );
    const renderPrinterTooltip = (props) => (
        <Tooltip id="printer-tooltip" {...props}>
            Printer
        </Tooltip>
    );
    const renderRefreshTooltip = (props) => (
        <Tooltip id="refresh-tooltip" {...props}>
            Refresh
        </Tooltip>
    );
    const renderCollapseTooltip = (props) => (
        <Tooltip id="refresh-tooltip" {...props}>
            Collapse
        </Tooltip>
    )

    const columns = [

        {
            title: "Category",
            dataIndex: "Name",
            sorter: (a, b) => a.Name.localeCompare(b.Name),
        },
        {
            title: "categorycode",
            dataIndex: "Code",
            sorter: (a, b) => a.Code.localeCompare(b.Code),
        },
        {
            title: "Description",
            dataIndex: "Description",
            sorter: (a, b) => a.Description.localeCompare(b.Description),
        },
        // {
        //     title: "Quantity",
        //     dataIndex: "Qty",
        //     sorter: (a, b) => a.Qty.localeCompare(b.Qty),
        // },

        {
            title: 'Is Default',
            dataIndex: 'IsDefault',
            render: (IsDefault) => (
                <span className={`badge badge-${IsDefault === true ? 'linesuccess' : 'linedanger'}`}>
                    {IsDefault === true ? 'Yes' : 'No'}
                </span>
            ),
            sorter: (a, b) => (a.IsDefault ? 1 : -1) - (b.IsDefault ? 1 : -1),
        },

        {
            title: 'Status',
            dataIndex: 'IsActive',
            render: (IsActive) => (
                <span className={`badge badge-${IsActive === true ? 'success' : 'danger'}`}>
                    {IsActive === true ? 'Active' : 'Inactive'}
                </span>
            ),
            sorter: (a, b) => (a.IsActive ? 1 : -1) - (b.IsActive ? 1 : -1),
        },

        {
            title: 'Actions',
            dataIndex: 'actions',
            key: 'actions',
            render: (text, record) => (
                <td className="action-table-data">
                    <div className="edit-delete-action">
                        <Link
                            className={`me-2 p-2 ${permissions.isWrite}`}
                            to="#"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvasRightSubCategoryEdit"
                            aria-controls="offcanvasRightSubCategoryEdit"
                            data-id="code"
                            onClick={() => showEditModal(record)}
                        >
                            <i data-feather="edit" className="feather-edit"></i>
                        </Link>

                        <Link
                            className={`confirm-text p-2 ${permissions.isDelete}`}
                            to="#"
                            onClick={() => showConfirmationAlert(record.Id)}
                        >
                            <i data-feather="trash-2" className="feather-trash-2"></i>
                        </Link>
                    </div>
                </td>
            )
        },
    ]

    const MySwal = withReactContent(Swal);

    const showConfirmationAlert = (categoryId) => {
        MySwal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#00ff00',
            cancelButtonColor: '#ff0000',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'Cancel'
        }).then((result) => {
            if (result.isConfirmed) {
                // Make a request to delete the category
                deleteCategory(categoryId);
            }
        });
    };

    const deleteCategory = (categoryId) => {

        const requestData = { "Id": categoryId, UpdatedBy: userDataSession.UserId };

        console.log(requestData, categoryId, 'resuwet data')

        Axios.post(`${API_BASE_URL}${DEL_SUB_CATEGORY}`, requestData)
            .then(response => {
                if (response.data.Status) {
                    // Show success message
                    MySwal.fire({
                        title: 'Deleted!',
                        text: 'Sub-Category has been deleted.',
                        icon: 'success',
                        confirmButtonColor: '#00ff00',
                    }).then(() => {
                        // Reload the page after the user clicks "OK"
                        window.location.reload();
                    });
                    // Optionally, you can update the category list after deletion
                } else {
                    // Show error message
                    MySwal.fire({
                        title: 'Error',
                        text: 'Failed to delete category.',
                        icon: 'error',
                        confirmButtonColor: '#00ff00',
                    });
                }
            })
            .catch(error => {
                console.error('Error deleting category:', error);
                // Show error message
                MySwal.fire({
                    title: 'Error',
                    text: 'Failed to delete category.',
                    icon: 'error',
                    confirmButtonColor: '#00ff00',
                });
            });
    };

    const [editSubCategoryObj, setEditSubCategoryObj] = useState([]);

    const showEditModal = (categoryObj) => {
        setEditSubCategoryObj(categoryObj); 
    };

    const filteredData = dataSource.filter(item => {
        const name = item.Name ? item.Name.toLowerCase() : '';
        const code = item.Code ? item.Code.toLowerCase() : '';
        const description = item.Description ? item.Description.toLowerCase() : '';
        const qty = item.Qty != null ? item.Qty.toString().toLowerCase() : '';
    
        return name.includes(searchQuery.toLowerCase()) ||
               code.includes(searchQuery.toLowerCase()) ||
               description.includes(searchQuery.toLowerCase()) ||
               qty.includes(searchQuery.toLowerCase());
    });
    

    const handleDownloadExcel = () => {
        if (data.length === 0) {
            return; // Don't download if there is no data
        }

        // Create a new workbook
        const wb = XLSX.utils.book_new();

        // Convert your data to worksheet format
        const wsData = dataSource?.map((item) => ({
            'Category Name': item.Name,
            'Category Code': item.Code,
            'Description': item.Description,
            'Quantity': item.Qty,
        }));

        const ws = XLSX.utils.json_to_sheet(wsData);

        // Add the worksheet to the workbook
        XLSX.utils.book_append_sheet(wb, ws, 'SubCategoryData');

        // Save the workbook to a file
        XLSX.writeFile(wb, 'SubCategoryData.xlsx');
    };

    const generatePDF = () => {
        const doc = new jsPDF();

        // Set properties for PDF
        doc.setProperties({
            title: 'Attendance Report',
            author: 'Your Name',
            creator: 'Your Application'
        });

        // Add data to PDF
        const tableData = []; // Your data array here

        // Add a header row
        const headers = ['Name', 'Code', 'Description', 'Quantity'];
        tableData.push(headers);

        // Add rows
        dataSource.forEach(item => {
            const row = [];
            row.push(item.Name, item.Code, item.Description, item.Qty);
            tableData.push(row);
        });

        // Generate table
        doc.autoTable({
            head: [headers],
            body: tableData.slice(1),
        });

        // Save the PDF
        doc.save('CaregoryData.pdf');
    };

    const handleReload = (e) => {
        e.preventDefault();
        window.location.reload();
    }

    return (
        <div>
            <div className="page-wrapper">
                <div className="content">
                    <div className="page-header">
                        <div className="add-item d-flex">
                            <div className="page-title">
                                <h4>Sub Category list</h4>
                                <h6>Manage your subcategories</h6>
                            </div>
                        </div>
                        <ul className="table-top-head">
                            <li className={` ${permissions.isExport}`} onClick={generatePDF}>
                                <OverlayTrigger placement="top" overlay={renderTooltip}>
                                    <Link>
                                        <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
                                    </Link>
                                </OverlayTrigger>
                            </li>
                            <li className={` ${permissions.isExport}`} onClick={handleDownloadExcel}>
                                <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                                    <Link data-bs-toggle="tooltip" data-bs-placement="top">
                                        <ImageWithBasePath src="assets/img/icons/excel.svg" alt="img" />
                                    </Link>
                                </OverlayTrigger>
                            </li>
                            <li>
                                <OverlayTrigger placement="top" overlay={renderPrinterTooltip}>

                                    <Link data-bs-toggle="tooltip" data-bs-placement="top">
                                        <i data-feather="printer" className="feather-printer" />
                                    </Link>
                                </OverlayTrigger>
                            </li>
                            <li>
                                <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>

                                    <Link data-bs-toggle="tooltip" data-bs-placement="top" onClick={handleReload}>
                                        <RotateCcw />
                                    </Link>
                                </OverlayTrigger>
                            </li>
                            <li>
                                <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>

                                    <Link
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        id="collapse-header"
                                        className={data ? "active" : ""}
                                        onClick={() => { dispatch(setToogleHeader(!data)) }}
                                    >
                                        <ChevronUp />
                                    </Link>
                                </OverlayTrigger>
                            </li>
                        </ul>
                        <div className={`page-btn ${permissions.isRead}`}>
                            <Link
                                to="#"
                                className="btn btn-added"
                                data-bs-toggle="offcanvas"
                                data-bs-target="#offcanvasRightSubCategoryAdd"
                                aria-controls="offcanvasRightSubCategoryAdd"
                            >
                                <PlusCircle className="me-2" />
                                Add 
                            </Link>
                        </div>
                    </div>
                    {/* /product list */}
                    <div className="card table-list-card">
                        <div className="card-body">
                            <div className="table-top">
                                <div className="search-set">
                                    <div className="input-group search-input">
                                        <input
                                            type="text"
                                            placeholder="Search"
                                            className="form-control form-control-sm formsearch"
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                        />
                                        <span className="input-group-text bg-white">
                                            <i data-feather="search" className="feather-search"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        
                            <div className="table-responsive">
                                {loading ? (
                                    <SpinLoader/>
                                    // <div className="loader m-auto"></div>
                                ) : (
                                    <Table columns={columns} dataSource={filteredData} />
                                )}

                            </div>
                        </div>
                    </div>
                    {/* /product list */}
                </div>
            </div>

            <AddSubcategory />
            <EditSubcategories subCategoryObj={editSubCategoryObj} />
        </div>
    )
}

export default SubCategories
